import React, { MouseEvent, useRef } from "react";

interface IUseResizeProps {
  setBodyHeight: (size: number) => void;
}

export const useResize = ({ setBodyHeight }: IUseResizeProps) => {
  const isResizing = useRef(false);

  const handleMouseDown = () => {
    isResizing.current = true;
  };

  const handleMouseMove = (e: globalThis.MouseEvent) => {
    if (!isResizing.current) return;
    const newHeight = e.clientY - 100; // Adjust offset as needed
    setBodyHeight(newHeight);
  };

  const handleMouseUp = () => {
    isResizing.current = false;
  };

  React.useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return { handleMouseDown };
};
